import React, { useState } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="w-100" style={{backgroundColor: '#6c5b5b'}}>
            <nav className="navbar navbar-expand-lg navbar-dark w-100">
                <div className="container-fluid">
                        
                        
                        {/* Mobile toggle button */}
                        <button 
                            className="navbar-toggler" 
                            type="button" 
                            onClick={toggleMenu}
                            aria-controls="navbarNav" 
                            aria-expanded={isMenuOpen} 
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        
                        {/* Navigation links */}
                        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item">
                                    <a href="/home" className="nav-link text-light">
                                        <i className="fas fa-home me-1"></i>
                                        Naslovna stranica
                                    </a>
                                </li>
                            
                                
                                <li className="nav-item">
                                    <a href="/kontakt" className="nav-link text-light">
                                        <i className="fas fa-envelope me-1"></i>
                                        Kontakt
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/onama" className="nav-link text-light">
                                        <i className="fas fa-info-circle me-1"></i>
                                        O nama
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
        </header>
    );
};

export default Header;